'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  fontFamily: 'TradeGothicLTStd-Cn18',
  width: '100%',
  height: '100px',
  '.navbarRow': {
    display: 'flex',
    margin: 'auto',
    backgroundColor: 'rgb(255,255,255)',
    color: 'black',
    borderBottom: 'solid .2px rgba(0,0,0,.17)',
    height: '64px',
    padding: '0 24px',
    textTransform: 'uppercase'
  },
  '& i': {
    marginRight: 5,
    marginTop: '-3px'
  },
  '& .item': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    margin: '0',
    padding: '0 1em',
    '& .noClick': {
      cursor: 'default'
    }
  },
  '& .subItem': {
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    margin: '0',
    display: 'inline-flex',
    flexDirection: 'column',
    padding: 0,
    marginLeft: '.5em',
    cursor: 'pointer',
    '& span': {
      display: 'flex',
      alignSelf: 'flex-start',
      fontSize: 10
    }
  },
  '& .left': {
    display: 'flex',
    justifyContent: 'flex-start',
    height: '100%',
    alignItems: 'center',
    marginTop: 0,
    '& i': {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer'
    }
  },
  '& .right': {
    height: '100%',
    justifyContent: 'flex-end',
    marginTop: 0
  },
  '& .menuItems': {
    top: '42px'
  },
  '& .userInfo': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '10px',
    height: '100%',
    margin: '0',
    '& .active': {
      color: 'black',
      cursor: 'pointer'
    },
    '& .active .menu > div': {
      color: 'black',
      cursor: 'pointer'
    }
  },
  '& .noClick': {
    cursor: 'default',
    color: 'lightgrey'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(props, theme) {
  return (0, _extends3.default)({}, (0, _objectResolvePath2.default)(theme, 'Navbar.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Navbar/Navbar.style.js
// module id = 617
// module chunks = 0